import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { BaseCta } from './BaseCta';

export const ReserveCta = ({ className, creditPrice, hideCreditText, onClick, tooltip, showReserveText }) => (
  <BaseCta
    className={classNames(className, 'bt--primary', {
      'bt--outline': !showReserveText,
    })}
    onClick={onClick}
    tooltipProps={tooltip ? { 'data-tooltip': tooltip } : null}>
    {showReserveText ? (
      <FormattedMessage id="Schedule.reserveCta" defaultMessage="Reserve" />
    ) : (
      <Fragment>
        <span>{creditPrice}</span>
        {!hideCreditText && <FormattedMessage id="Schedule.creditsCta" defaultMessage="credits" />}
      </Fragment>
    )}
  </BaseCta>
);

ReserveCta.propTypes = {
  className: PropTypes.string,
  creditPrice: PropTypes.number,
  hideCreditText: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  showReserveText: PropTypes.string,
  tooltip: PropTypes.string,
};
